module.exports = __webpack_public_path__ + "img/IOT01.9b300ebe.jpg";